import IPagination from '../../../common/interfaces/IPagination';
import HomeConstants from '../../home/constants';
import IReportsHistoricDataTable from '../components/interfaces/IReportsHistoricDataTable';

export const PATH = '/reports';
export const PAGE_TITLE = 'Relatorios';

export const HISTORIC_DEFAULT_DATA = {
    currentPage: 0,
    data: [] as IReportsHistoricDataTable[],
    totalItems: 0,
    totalPages: 0,
} as IPagination<IReportsHistoricDataTable>;

export const BREADCRUMB_DATA = [
    {
        label: HomeConstants.PAGE_TITLE,
        href: HomeConstants.PATH,
    },
    {
        label: PAGE_TITLE,
        href: PATH,
    },
];
